<template>
  <div class="security">
    <div class="label">
      <div class="title">登录设置</div>
    </div>
    <van-cell-group class="menu">
      <van-cell is-link to="password" title-class="cell-title"
        title="登录密码" value="******" 
      />
    </van-cell-group>
    <div class="label">
      <div class="title">绑定信息</div>
    </div>
    <van-cell-group class="menu">
      <van-cell is-link to="reset-mobile" title-class="cell-title" title="手机绑定" :value="userFullInfo.mobilePhone" />
      <van-cell is-link to="reset-email" title-class="cell-title" title="邮箱绑定" :value="userFullInfo.mailBox" />
      <van-cell is-link title-class="cell-title" title="微信绑定" :value="userFullInfo.SFBDWX | getSFBDWX" />
    </van-cell-group>
  </div>
</template>

<script>
import api from '@/utils/api/personCenter'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  components: {},
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      userInfo:{},// 用户信息
      userFullInfo:{},// 用户个人信息
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '账号安全'
    }
  },
  methods: {
    // 刷新个人中心数据
    refreshUserInfo(){
      // localStorage.removeItem('userInfo')// 清除用户包括附件的用户信息
      localStorage.removeItem('userFullInfo')// 清除用户包括附件的用户信息
      this.getLoginData()
      this.getData()
    },
    // 获取userInfo数据
    getLoginData(){

    },
    getUserInfo(){

    },
    // 获取userFullInfo数据
    getData() {
      // this.userInfo = this.$store.state.userInfo
      let params = {}
      // 获取用户完整信息
      api
        .getLoginUserInfo(params)
        .then(res => {
          console.log(res)
          this.userFullInfo = res.data

          this.$store.commit('setFullUserInfo', res.data)
          // if(res.code == 500){
          //   this.$dialog.confirm({
          //     title: '—— 温馨提示 ——',
          //     message: res.message,
          //     confirmButtonText: '去登录',
          //     confirmButtonColor: '#1D84FF'
          //   })
          //   .then(() => {
          //     this.logIn()
          //   }).catch(() => {
          //     // on cancel
          //   });
          // }
       
        })
        .catch(err => {
          // console.log(err.response)
          this.$dialog.confirm({
            title: '—— 温馨提示 ——',
            message: err.response.data.message,
            confirmButtonText: '去登录',
            confirmButtonColor: '#1D84FF'
          })
          .then(() => {
            this.logIn()
          }).catch(() => {
            // on cancel
          });
        })
    },
    logIn() {
      if (this.$store.state.loginConfig.isHaveThirdLogin == 1) {
        //第三方登录，统一身份登录一定要小程序
        if (window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: '/pages/faceWebview/faceWebview?currentUserType=1'
          })
        } else {
          this.$toast('请使用小程序登录')
        }
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    logOut() {
      this.$store.commit('cleanUserInfo')
      localStorage.removeItem('userInfo')// 清除用户登录信息
      localStorage.removeItem('userFullInfo')// 清除用户包括附件的用户信息

      // if (this.$store.state.loginConfig.isHaveThirdLogin == 1) {
      //   if (window.__wxjs_environment === 'miniprogram') {
      //     wx.miniProgram.navigateTo({
      //       url: '/pages/logOut/logOut'
      //     })
      //   } else {
      //     this.$toast('请使用小程序登录')
      //   }
      // }
      let params = {}
      api
        .logOut(params)
        .then(res => {
          console.log("logOut:",res)
        })
        .catch(err => {

        })
    },
  },
  filters:{
    getSFBDWX(val){
      if(val){
        return "已绑定"
      }else{
        return "未绑定";
      }
    },
  },
  created() {},
  mounted() {
    this.userInfo = this.$store.state.userInfo ? this.$store.state.userInfo : '';
    this.userFullInfo = this.$store.state.userFullInfo ? this.$store.state.userFullInfo : '';

    this.$bus.$on('refreshUserInfo', () => {
      this.refreshUserInfo()
    })
  }
};
</script>
<style lang="scss" scoped>
.security{
  .label {
    padding: 10px;
  }
  .menu {
    .van-cell {
      justify-content: center;
      align-items: center;
      padding: 18px 16px;
      .cell-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 450;
        color: #333333;
        margin-left: 5px;
        line-height: 1;
      }
      ::v-deep .van-cell__value {
        color: #1d84ff;
      }
    }
  }
}
</style>